import React from 'react';
import { applicationStatusData } from 'components/FAQs/FAQsData';
import { useLocale } from 'hooks/useLocale';
import styles from './ApplicationStatusInfo.module.css';

export const ApplicationStatusInfo = () => {
  const { isDE } = useLocale();

  const descriptionsToDisplay = isDE
    ? applicationStatusData()?.filter((desc) => desc.showInDE)
    : applicationStatusData();

  return (
    <div className={styles.applicationStatusInfo}>
      {descriptionsToDisplay.map(({ value, description }) => (
        <section key={value}>
          <h4>{value}</h4>
          <p>{description}</p>
        </section>
      ))}
    </div>
  );
};
